module.exports = __webpack_public_path__ + "img/bg-bottom.e5286b8c.webp";